const NumberToKorean = ({ num }) => {
    if (typeof num !== 'number' || !Number.isInteger(num) || num < 0) {
        throw new Error('0 이상의 정수만 입력 가능합니다.');
      }
      if (num === 0) return '영원';
    
      const digits     = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
      const smallUnits = ['', '십', '백', '천'];
      const bigUnits   = ['', '만', '억', '조', '경', '해'];
    
      let result = '';
      let unitIdx = 0;
    
      // 4자리씩 잘라서 처리
      while (num > 0) {
        const chunk = num % 10000;
        if (chunk > 0) {
          let chunkStr = '';
          for (let i = 0; i < 4; i++) {
            const digit = Math.floor(chunk / (10 ** i)) % 10;
            if (digit > 0) {
              chunkStr = digits[digit] + smallUnits[i] + chunkStr;
            }
          }
          result = chunkStr + bigUnits[unitIdx] + result;
        }
        num = Math.floor(num / 10000);
        unitIdx++;
      }
    
      return result + '원';
}

export default NumberToKorean;